import React from 'react';
import classNames from 'classnames';

import css from './VerifiedCreatorCardSkeleton.module.css';

const VerifiedCreatorCardSkeleton = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes} aria-hidden="true">
      <div className={css.image} />
      <div className={css.meta}>
        <div className={classNames(css.line, css.category)} />
        <div className={classNames(css.line, css.title)} />
        <div className={classNames(css.line, css.subtitle)} />
        <div className={classNames(css.line, css.cta)} />
      </div>
    </div>
  );
};

export default VerifiedCreatorCardSkeleton;
